import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { LinkButton } from 'components/Button';
import './index.sass';

const { block } = bem('start-meeting-button');

export const StartMeetingButton = ({orderId}) => {
    return (
        <LinkButton className={ block() } mod={ 'gold' } to={`/orders/${orderId}/conference`}>
            <Text>Начать консультацию</Text>
            <Icon name={'headset'} />
        </LinkButton>
    )
}
